import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Links from './pages/Links';
import Dashboard from './pages/Dashboard';
import Corporate from './pages/Corporate';
import Booking from './pages/Booking';
import { Toaster } from './components/ui/sonner';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/links" element={<Links />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/corporate" element={<Corporate />} />
          <Route path="/booking" element={<Booking />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;